<div class="main-container">
    <div class="modal-header">
        <img src="../../../assets/svg/close-button.svg" class="modal-close-btn" (click)="close(false);$event.stopPropagation()">
    </div>
    <div class="modal-body">
        <h2 class="update-phase-title">{{data.title.key | translate}}</h2>
        <span class="update-phase-description">{{data.description.key | translate}}</span>
        <app-update-project-phase
            [phases]="data.phases"
            (updatePhase)="getPhaseData($event)"></app-update-project-phase>
        <div class="buttons-container">
            <button pButton [ngClass]="button.className" [label]="(button.labelKey | translate)" *ngFor="let button of data.buttons" (click)="close(button.value);$event.stopPropagation()"></button>
        </div>
    </div>
</div>